export default __webpack_public_path__ + "static/media/img-egt-crs@2x.c01e317e.png";